<div class="salesforce-form">
  <div class="salesforce-form-header">
    <svg-icon class="header-icon" icon="{{ group.icon }}"></svg-icon>
    <span class="create-button-label">{{ "salesforceForm.createNew" | translate: { itemName: group.name } }}</span>
  </div>

  <div *ngIf="form" class="salesforce-form-body">
    <form [formGroup]="form" class="form-wrapper">
      <div *ngFor="let section of salesforceFormData.sections">
        <div *ngFor="let field of section.fields">
          <app-salesforce-field [chatId]="chatId" [field]="field" [form]="form" [context]="group.id" [errorText]="getErrorText(field)"></app-salesforce-field>
        </div>
      </div>
    </form>

    <div class="button-list">
      <button type="submit" [disabled]="!form.valid || isSavingSalesforceObject" class="btn btn-dark" (click)="onSaveAndLinkClick()">
        <span>{{ "salesforceForm.saveAndLink" | translate }}</span>
      </button>

      <button class="btn btn-light" (click)="onCancelClick()">
        <span>{{ "salesforceForm.cancel" | translate }}</span>
      </button>
    </div>
  </div>

  <app-loading *ngIf="isLoading" [description]="'bcLoading.loadingText'"></app-loading>
</div>
